/**
 * Webpack configurations that need to be set/overridden dynamically.
 */

/* jshint ignore:start */
__webpack_public_path__ = window.__webpack_public_path__;
/* jshint ignore:end */
